import React, { useState } from "react";
import axios from "axios";

function App() {
  const [location, setLocation] = useState("");
  const [info, setInfo] = useState("");
  const url = `https://api.openweathermap.org/data/2.5/weather?q=${location}&appid=6f80c2e421237d7e5c8a77f21fa25007&units=metric`;

  const search = (e) => {
    if (e.key === "Enter") {
      axios
        .get(url)
        .then((r) => {
          setInfo(r.data);
          console.log(r.data);
          setLocation("");
        })
        .catch((error) => {
          setInfo({
            "coord": {
              
            },
            weather: [{}],
            base: "stations",
            main: {
              temp: "__",
              feels_like: "__",
              temp_min: "__",
              temp_max: "__",
              humidity: "__",
            },
            wind: {
              speed: "__",
            },
            name: "Invalid location...try again",
          });
          console.log(info);
          setLocation("");
        });
    }
  };

  return (
    <div className="App">
      <div className="search">
        <h2>What's the current weather for...</h2> <br></br>
        <input
          value={location}
          onChange={(e) => setLocation(e.target.value)}
          placeholder="Enter Location..."
          onKeyDown={search}
        />
        <br></br>
        <small>Enter <u>city name</u> followed by <u>comma</u> and <u>country code</u> (e.g. London, CA)</small> <br></br>
        <small>Otherwise, a default country will be used</small>
      </div>
    
      <div className="wrap">
        <div className="top">
          <div>
            <p>
              {info.name}
              {info.sys ? <>, {info.sys.country}</> : null}
            </p>
          </div>

          <div>
            {info.main && info.main.temp !== "__" ? (
              <h1>{info.main.temp}°C</h1>
            ) : null}

            <div className="desc">
              {info.main ? <p>{info.weather[0].main}</p> : null}
            </div>
          </div>
          
          
          <div className="details">

          

          {info.main && info.main.temp !== "__" ? (
            <h3>Min Temp: {info.main.temp_min}°C</h3>
          ) : null}
          {info.main && info.main.temp !== "__" ? (
            <h3>Max Temp: {info.main.temp_max}°C</h3>
          ) : null}

          <br></br>

          {info.main && info.main.temp !== "__" ? <small>longitude: {info.coord.lon}</small> : null} <br></br>
          {info.main && info.main.temp !== "__" ? <small>latitude: {info.coord.lat}</small> : null}
          </div>
        </div>

        {info.main ? 
        <div className="bot">
          <div className="humid">
            <b>
              <p>Humidity</p>
            </b>
            {info.main ? <p>{info.main.humidity}%</p> : null}
          </div>

          <div className="feel">
            <b>
              <p>Feels like</p>
            </b>
            {info.main ? <p>{info.main.feels_like}°C</p> : null}
          </div>

          <div className="wind">
            <b>
              <p>Wind Speed</p>
            </b>
            {info.main ? <p>{info.wind.speed} MPH</p> : null}
          </div>
        </div> : null}


      </div>
    </div>
  );
}

export default App;
